import { UpdateUserRequest, User } from "@/types";
import { apiFetch } from "../fetch";
import { getAccessToken } from "@/utils";

export async function getUser(
  identifier: string,
  token?: string,
): Promise<User> {
  return apiFetch<User>(`/users/${encodeURIComponent(identifier)}`, {
    method: "GET",
    token: getAccessToken(),
    headers: {
      //TO DO: THIS SHOULD BE TEMPORARILY
      "x-saasbase-project-id": "proj_06fghx60hnrcxftadsj44e0pj8",
    },
    // token,
  });
}

export async function updateUser(
  identifier: string,
  data: UpdateUserRequest,
): Promise<User> {
  return apiFetch<User>(`/users/${encodeURIComponent(identifier)}`, {
    method: "PATCH",
    body: JSON.stringify(data),
    token: getAccessToken(),
    headers: {
      //TO DO: THIS SHOULD BE TEMPORARILY
      "x-saasbase-project-id": "proj_06fghx60hnrcxftadsj44e0pj8",
    },
  });
}
